import React from "react";
import { useDispatch } from "react-redux";
import { showCitations } from "../../state/actions";
import "./SourcesPill.scss";

const SourcesPill = ({ sources = [] }) => {
    const dispatch = useDispatch();
    const visibleSources = sources.slice(0, 3);
    const remainingSources = sources.length - visibleSources.length;

    return (
        <button
            type="button"
            className="sources-pill"
            onClick={() => dispatch(showCitations(sources))}
        >
            <div className="source-icons">
                {visibleSources.map((src, index) => {
                    const label = src.title || src.tile || src.source || "";
                    const initial = (label || "?").charAt(0).toUpperCase();
                    return (
                    <div key={index} className="source-icon">
                        {src.icon && String(src.icon).startsWith("http") ? (
                            <img src={src.icon} alt={src.source || label || "Source"} />
                        ) : (
                            <span className="fallback-text">{initial}</span>
                        )}
                    </div>
                    );
                })}
            </div>
            {sources.length > 0 && (
                <span className="remaining-sources">
                    {remainingSources > 0 ? `+${remainingSources} Sources` : "Sources"}
                </span>
            )}
        </button>
    );
};

export default SourcesPill;
